import { mutationOptions, useQueryClient } from '@tanstack/react-query';

import type { RecordPaymentRequest, RefundPaymentInput } from '../model/payment.types';
import { paymentApi } from './payment.api';
import { queryKeys } from './payment.queries';

export function useRecordPaymentOptions() {
    const queryClient = useQueryClient();
    return mutationOptions({
        mutationFn: (request: RecordPaymentRequest) => paymentApi.record(request),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.all }),
    });
}

export function useRefundPaymentOptions() {
    const queryClient = useQueryClient();
    return mutationOptions({
        mutationFn: (request: RefundPaymentInput) => paymentApi.refund(request),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.all }),
    });
}
